// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Proverbs",
  bookSlug: "proverbs",
  chapter: 17,
  argument: "",
  verses: [
    { n: 1, text: "Better is a dry morsel with joy, than a house full of victims with strife." },
    { n: 2, text: "A wise servant shall rule over foolish sons, and shall divide the inheritance among the brethren." },
    { n: 3, text: "As silver is tried by fire, and gold in the furnace: so the Lord trieth the hearts." },
    { n: 4, text: "The evil man obeyeth an unjust tongue: and the deceitful hearkeneth to lying lips." },
    { n: 5, text: "He that despiseth the poor, reproacheth his maker: and he that rejoiceth at another man's ruin, shall not be unpunished." },
    { n: 6, text: "Children's children are the crown of old men: and the glory of children are their fathers." },
    { n: 7, text: "Eloquent words do not become a fool, nor lying lips a prince." },
    { n: 8, text: "The expectation of him that expecteth is a most acceptable jewel: whithersoever he turneth himself, he understandeth wisely." },
    { n: 9, text: "He that concealeth a transgression, seeketh friendships: he that repeateth it again, separateth friends." },
    { n: 10, text: "A reproof availeth more with a wise man, than a hundred stripes with a fool." },
    { n: 11, text: "An evil man always seeketh quarrels: but a cruel angel shall be sent against him." },
    { n: 12, text: "It is better to meet a bear robbed of her whelps, than a fool trusting in his own folly." },
    { n: 13, text: "He that rendereth evil for good, evil shall not depart from his house." },
    { n: 14, text: "The beginning of quarrels is as when one letteth out water: before he suffereth reproach, he forsaketh judgment." },
    { n: 15, text: "He that justifieth the wicked, and he that condemneth the just, both are abominable before God." },
    { n: 16, text: "What doth it avail a fool to have riches, seeing he cannot buy wisdom? He that maketh his house high, seeketh a downfall: and he that refuseth to learn, shall fall into evils." },
    { n: 17, text: "He that is a friend loveth at all times: and a brother is proved in distress." },
    { n: 18, text: "A foolish man will clap hands, when he is surety for his friend." },
    { n: 19, text: "He that studieth discords, loveth quarrels: and he that exalteth his door, seeketh ruin." },
    { n: 20, text: "He that is of a perverse heart, shall not find good: and he that perverteth his tongue, shall fall into evil." },
    { n: 21, text: "A fool is born to his own disgrace: and even his father shall not rejoice in a fool." },
    { n: 22, text: "A joyful mind maketh age flourishing: a sorrowful spirit drieth up the bones." },
    { n: 23, text: "The wicked man taketh gifts out of the bosom, that he may pervert the paths of judgment." },
    { n: 24, text: "Wisdom shineth in the face of the wise: the eyes of fools are in the ends of the earth." },
    { n: 25, text: "A foolish son is the anger of the father: and the sorrow of the mother that bore him." },
    { n: 26, text: "It is no good thing to do hurt to the just: nor to strike the prince, who judgeth right." },
    { n: 27, text: "He that setteth bounds to his words, is knowing and wise: and the man of understanding is of a precious spirit." },
    { n: 28, text: "Even a fool, if he will hold his peace, shall be counted wise: and if he close his lips, a man of understanding." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Victims. Of which part was used for a feast, chap. vii. 14. (Calmet) — Septuagint add, \"of many goods, and unjust victims.\"", attribution: "Haydock" }
    ] },
    { verse: 2, notes: [
      { text: "Brethren. Partaking with them, (Abenezra; Tirinus; Menochius) or rather acting as his master's executor; which evinces the advantages of wisdom, so as to raise a slave above those whom his station requires him to serve. Such was Joseph, who was tried.", attribution: "Haydock" }
    ] },
    { verse: 4, notes: [
      { text: "Lips. They mutually deceive one another, as well as others.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Fathers. Whose virtues they are bound to imitate.", attribution: "Haydock" }
    ] },
    { verse: 7, notes: [
      { text: "Eloquent. Septuagint, \"faithful.\" They cannot be expected from them.", attribution: "Haydock" }
    ] },
    { verse: 8, notes: [
      { text: "Expecteth heavenly things. Septuagint, \"instruction is the reward of good deeds to those who use it.\"", attribution: "Haydock" }
    ] },
    { verse: 9, notes: [
      { text: "Friends. Detractors cause dissensions, and even wars.", attribution: "Haydock" }
    ] },
    { verse: 10, notes: [
      { text: "Fool. \"A word is enough for the wise.\" Nobilis equus umbra virg� regitur, ignavus ne calcari quidem.", attribution: "Q. Curt." }
    ] },
    { verse: 11, notes: [
      { text: "Angel. Messenger of death, (Menochius) which is sometimes inflicted by good, at others by bad, angels of death, or satan, 2 Corinthians xii. 7., and Psalm lxxvii. 49.", attribution: "Haydock" }
    ] },
    { verse: 12, notes: [
      { text: "Fool. Hebrew, \"fool in his folly.\" The danger is not greater in meeting (Calmet) a female bear, though it be the most terrible.", attribution: "Aristotle, Anim. ix. 1." }
    ] },
    { verse: 14, notes: [
      { text: "Water. It is scarcely possible to prevent the bad effects of detraction. Frequent quarrels have also risen on account of springs, Genesis xxvi. 20. — Judgment. And gives up the cause, as being much more prudent, Matthew v. 25, 40.", attribution: "Haydock" }
    ] },
    { verse: 15, notes: [
      { text: "God. We ought to suspend our judgment, or incline to the more favourable side, Matthew vii. 1., and Romans ii. 1.", attribution: "Haydock" }
    ] },
    { verse: 16, notes: [
      { text: "He, &c., is not here in Hebrew, though it be equivalently (", attribution: "Haydock" }
    ] },
    { verse: 19, notes: [
      { text: ") where the Septuagint are silent.", attribution: "Calmet" }
    ] },
    { verse: 17, notes: [
      { text: "Distress. Like the real friend, chap. xviii. 24.", attribution: "Haydock" }
    ] },
    { verse: 18, notes: [
      { text: "Hands. Through joy, or as a mark of his consent.", attribution: "Haydock" }
    ] },
    { verse: 24, notes: [
      { text: "Earth. Wandering and insatiable, and deeming the acquisition of wisdom too difficult.", attribution: "Haydock" }
    ] },
    { verse: 26, notes: [
      { text: "No good. But very criminal. See Jeremias vii. 31.", attribution: "Haydock" }
    ] },
    { verse: 27, notes: [
      { text: "Precious and reserved spirit. This is a mark of wisdom.", attribution: "Calmet" }
    ] },
  ],
};

export default chapter;
